var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJavascript(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 300",
    "data-imageid": "html-0",
    imageName: "Javascript",
    className: "illustrations_image",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_181_code_javascript_flatline",
    "data-name": "#181_code_javascript_flatline"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M244.21,119s.42-6.69-2.82-8.27-15.76-4.53-15.76,1.93,8,12.53,9.41,13.38,8.06,20.64,8.06,20.64L257.84,130Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.1,147.19H243a.49.49,0,0,1-.38-.33c-3.13-9.34-6.94-19.66-7.85-20.38-1.57-.93-9.64-7.12-9.64-13.8a3.82,3.82,0,0,1,1.86-3.46c3.78-2.36,12.1-.16,14.62,1.08,3.16,1.54,3.16,7.18,3.11,8.49l13.44,10.82a.52.52,0,0,1,.18.35.5.5,0,0,1-.12.37L243.47,147A.48.48,0,0,1,243.1,147.19Zm-11.45-38a8,8,0,0,0-4.13.88,2.84,2.84,0,0,0-1.39,2.61c0,6.13,7.74,12.1,9.17,13s6.16,14.66,8,20.09l13.83-15.66L243.9,119.4a.49.49,0,0,1-.19-.42c0-.07.36-6.38-2.53-7.79A26,26,0,0,0,231.65,109.18Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.87,
    y: 190.52,
    width: 54.58,
    height: 9.06,
    transform: "translate(174.33 390.09) rotate(-180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.45,200.07H59.87a.5.5,0,0,1-.5-.5v-9a.5.5,0,0,1,.5-.5h54.58a.5.5,0,0,1,.5.5v9A.5.5,0,0,1,114.45,200.07Zm-54.08-1H114v-8H60.37Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.05,
    y: 190.52,
    width: 31.4,
    height: 9.06,
    transform: "translate(197.5 390.09) rotate(-180)",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.45,200.07H83.05a.5.5,0,0,1-.5-.5v-9a.5.5,0,0,1,.5-.5h31.4a.5.5,0,0,1,.5.5v9A.5.5,0,0,1,114.45,200.07Zm-30.9-1H114v-8H83.55Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.06,
    y: 181.11,
    width: 54.58,
    height: 9.06,
    transform: "translate(160.69 371.28) rotate(-180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.64,190.67H53.06a.5.5,0,0,1-.5-.5v-9.06a.5.5,0,0,1,.5-.5h54.58a.5.5,0,0,1,.5.5v9.06A.51.51,0,0,1,107.64,190.67Zm-54.08-1h53.58v-8.06H53.56Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.23,
    y: 181.11,
    width: 31.4,
    height: 9.06,
    transform: "translate(183.87 371.28) rotate(-180)",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.64,190.67H76.23a.51.51,0,0,1-.5-.5v-9.06a.5.5,0,0,1,.5-.5h31.41a.5.5,0,0,1,.5.5v9.06A.51.51,0,0,1,107.64,190.67Zm-30.91-1h30.41v-8.06H76.73Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.87,
    y: 171.7,
    width: 54.58,
    height: 9.06,
    transform: "translate(174.33 352.47) rotate(-180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.45,181.26H59.87a.5.5,0,0,1-.5-.5V171.7a.51.51,0,0,1,.5-.5h54.58a.5.5,0,0,1,.5.5v9.06A.5.5,0,0,1,114.45,181.26Zm-54.08-1H114V172.2H60.37Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.05,
    y: 171.7,
    width: 31.4,
    height: 9.06,
    transform: "translate(197.5 352.47) rotate(-180)",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.45,181.26H83.05a.5.5,0,0,1-.5-.5V171.7a.5.5,0,0,1,.5-.5h31.4a.5.5,0,0,1,.5.5v9.06A.5.5,0,0,1,114.45,181.26Zm-30.9-1H114V172.2H83.55Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.72,
    y: 210.66,
    width: 75.26,
    height: 35.47,
    transform: "translate(416.7 456.78) rotate(-180)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246,246.62H170.72a.5.5,0,0,1-.5-.5V210.66a.5.5,0,0,1,.5-.5H246a.5.5,0,0,1,.5.5v35.46A.5.5,0,0,1,246,246.62Zm-74.76-1h74.26V211.16H171.22Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.43,
    y: 199.69,
    width: 221.72,
    height: 10.97,
    rx: 3.48,
    transform: "translate(318.57 410.35) rotate(-180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.66,211.16H51.91a4,4,0,0,1-4-4v-4a4,4,0,0,1,4-4H266.66a4,4,0,0,1,4,4v4A4,4,0,0,1,266.66,211.16Zm-214.75-11a3,3,0,0,0-3,3v4a3,3,0,0,0,3,3H266.66a3,3,0,0,0,3-3v-4a3,3,0,0,0-3-3Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.43,
    y: 199.69,
    width: 129.42,
    height: 10.97,
    rx: 2.44,
    transform: "translate(226.28 410.35) rotate(-180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.41,211.16H50.87a2.94,2.94,0,0,1-2.94-2.94v-6.09a2.94,2.94,0,0,1,2.94-2.94H175.41a2.94,2.94,0,0,1,2.94,2.94v6.09A2.94,2.94,0,0,1,175.41,211.16Zm-124.54-11a1.94,1.94,0,0,0-1.94,1.94v6.09a1.94,1.94,0,0,0,1.94,1.94H175.41a1.94,1.94,0,0,0,1.94-1.94v-6.09a1.94,1.94,0,0,0-1.94-1.94Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158,153.79s-3,31.05,3.68,35.26c6.23,3.9,13.14,2.76,17,2.76a6.66,6.66,0,0,1,6.58,4.39l1,3.37h-48a29.29,29.29,0,0,1-8.89-9.19c-3.22-5.67-1.22-35.14-1.22-35.14Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.23,200.07h-48A.48.48,0,0,1,138,200a29.46,29.46,0,0,1-9.06-9.38c-3.26-5.73-1.38-34.2-1.29-35.41a.51.51,0,0,1,.47-.47l29.83-1.45a.48.48,0,0,1,.39.16.46.46,0,0,1,.13.39c0,.08-.75,7.84-.67,16,.11,10.67,1.53,17.16,4.13,18.79,5.06,3.16,10.53,2.92,14.53,2.75.8,0,1.53-.07,2.18-.07a7.18,7.18,0,0,1,7.05,4.74l1,3.38a.49.49,0,0,1-.07.44A.51.51,0,0,1,186.23,200.07Zm-47.83-1h47.15l-.82-2.73a6.19,6.19,0,0,0-6.1-4c-.64,0-1.36,0-2.14.07-3.9.17-9.78.43-15.1-2.91-6.47-4.05-4.37-30.74-4-35.15l-28.81,1.4c-.23,3.7-1.71,29.31,1.19,34.41A28.74,28.74,0,0,0,138.4,199.07Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.43,183.33c0,7.66,2.3,10,5.37,10h12a4.05,4.05,0,0,1,3.8,2.65l1.33,3.63H134.42c-4.75,0-8.12-7.2-8.28-14.86s0-29.47,0-29.47h4.14S130.43,175.66,130.43,183.33Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153,200.07H134.42c-5.3,0-8.63-7.8-8.78-15.35s0-29.26,0-29.48a.51.51,0,0,1,.5-.5h4.14a.5.5,0,0,1,.5.5c0,.2.15,20.51.15,28.09,0,9.46,3.67,9.46,4.87,9.46h12a4.57,4.57,0,0,1,4.27,3l1.33,3.63a.53.53,0,0,1-.06.46A.49.49,0,0,1,153,200.07Zm-26.33-44.33c0,3.3-.14,22,0,29,.16,7.92,3.65,14.37,7.78,14.37h17.83l-1.08-2.95a3.57,3.57,0,0,0-3.33-2.33h-12c-4,0-5.87-3.42-5.87-10.46s-.12-24.41-.14-27.59Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.2,69.23l7.26,83a6.58,6.58,0,0,1-6.49,7.43H97a8.13,8.13,0,0,1-7.79-7.43l-7.26-83a6.57,6.57,0,0,1,6.49-7.42h99A8.11,8.11,0,0,1,195.2,69.23Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196,160.17H97a8.64,8.64,0,0,1-8.29-7.89l-7.26-83a7.4,7.4,0,0,1,1.86-5.74,6.85,6.85,0,0,1,5.13-2.23h99a8.63,8.63,0,0,1,8.29,7.88l7.26,83a7.44,7.44,0,0,1-1.86,5.74A6.9,6.9,0,0,1,196,160.17ZM88.43,62.31A5.85,5.85,0,0,0,84,64.21a6.46,6.46,0,0,0-1.61,5l7.27,83a7.61,7.61,0,0,0,7.29,7h99a5.89,5.89,0,0,0,4.39-1.91,6.46,6.46,0,0,0,1.61-5l-7.27-83h0a7.6,7.6,0,0,0-7.29-7Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.53,68.9l6.94,79.25a6.29,6.29,0,0,1-6.21,7.09h-94.5a7.76,7.76,0,0,1-7.44-7.09L87.38,68.9a6.28,6.28,0,0,1,6.21-7.09h94.5A7.75,7.75,0,0,1,195.53,68.9Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.26,155.74h-94.5a8.26,8.26,0,0,1-7.94-7.54L86.89,68.94a7.1,7.1,0,0,1,1.78-5.5,6.61,6.61,0,0,1,4.92-2.13h94.5A8.26,8.26,0,0,1,196,68.85L203,148.11a7.1,7.1,0,0,1-1.78,5.5A6.62,6.62,0,0,1,196.26,155.74ZM93.59,62.31a5.58,5.58,0,0,0-4.18,1.81,6.11,6.11,0,0,0-1.53,4.73l6.94,79.26a7.24,7.24,0,0,0,6.94,6.63h94.5a5.58,5.58,0,0,0,4.18-1.81A6.16,6.16,0,0,0,202,148.2L195,68.94h0a7.24,7.24,0,0,0-6.94-6.63Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.3,134.84l1.17,13.31a6.29,6.29,0,0,1-6.21,7.09h-94.5a7.76,7.76,0,0,1-7.44-7.09l-1.17-13.31Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.26,155.74h-94.5a8.26,8.26,0,0,1-7.94-7.54l-1.16-13.31a.45.45,0,0,1,.13-.38.46.46,0,0,1,.36-.17H201.3a.5.5,0,0,1,.5.46L203,148.11a7.1,7.1,0,0,1-1.78,5.5A6.62,6.62,0,0,1,196.26,155.74ZM93.7,135.34l1.12,12.77a7.24,7.24,0,0,0,6.94,6.63h94.5a5.58,5.58,0,0,0,4.18-1.81A6.16,6.16,0,0,0,202,148.2l-1.13-12.86Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 148.12,
    cy: 145.04,
    rx: 4.29,
    ry: 4.73,
    transform: "translate(-55.67 107.03) rotate(-33.83)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.52,150.14a5.53,5.53,0,0,1-5.31-5,4.76,4.76,0,0,1,1.2-3.71,4.42,4.42,0,0,1,3.31-1.44A5.54,5.54,0,0,1,153,145h0a4.76,4.76,0,0,1-1.2,3.71A4.44,4.44,0,0,1,148.52,150.14Zm-.8-9.2a3.44,3.44,0,0,0-2.57,1.12,3.81,3.81,0,0,0-1,2.94,4.51,4.51,0,0,0,4.32,4.14,3.43,3.43,0,0,0,2.57-1.11,3.82,3.82,0,0,0,.95-2.94h0A4.52,4.52,0,0,0,147.72,140.94Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.04,
    y: 195.7,
    width: 72.73,
    height: 3.99,
    transform: "translate(380.81 395.39) rotate(-180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.77,200.19H154a.5.5,0,0,1-.5-.5v-4a.5.5,0,0,1,.5-.5h72.73a.5.5,0,0,1,.5.5v4A.5.5,0,0,1,226.77,200.19Zm-72.23-1h71.73v-3H154.54Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,215s-33.59,8.48-33.59,31.17h88.79s14.12-13.63,10.63-34.57C267.06,212.78,237,215,237,215Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.21,246.62H203.42a.5.5,0,0,1-.5-.5c0-22.82,33.63-31.56,34-31.65H237c.3,0,30.47-2.19,65.85-3.41a.48.48,0,0,1,.51.42c3.49,21-10.64,34.87-10.78,35A.52.52,0,0,1,292.21,246.62Zm-88.29-1H292c1.44-1.48,13.38-14.48,10.42-33.56-34.53,1.21-64,3.29-65.33,3.39C235.77,215.8,204.4,224.3,203.92,245.62Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.94,100s7.94-5.79,10.19-9.39,7.28-28.76-4.46-26.84c-11.54-16.47-35.25-9.49-38.83.68-3.15,8.93,8.34,11,12.32,12.23s8.26,20.19,13.7,23.32S280.94,100,280.94,100Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.11,101.86a9.35,9.35,0,0,1-4.5-1.46c-3-1.72-5.48-7.61-7.9-13.3-2-4.65-4-9.46-5.7-10-.42-.13-.92-.27-1.48-.42-3.37-.94-9-2.52-11-6.35a7.46,7.46,0,0,1-.16-6.1c1.82-5.17,8.59-9.53,16.45-10.61,9.4-1.28,17.79,2.2,23.08,9.56a5.58,5.58,0,0,1,5.78,2.52c4.23,6.35.62,22.33-1.13,25.13-2.18,3.49-9.34,8.81-10.23,9.47a3.5,3.5,0,0,1-1.94,1.37A4.38,4.38,0,0,1,278.11,101.86ZM267.6,54.37a26.62,26.62,0,0,0-3.64.25c-7.51,1-13.95,5.12-15.65,9.95a6.52,6.52,0,0,0,.11,5.31c1.79,3.44,7.17,5,10.38,5.84l1.51.44c2.13.67,4.07,5.25,6.32,10.55s4.78,11.27,7.48,12.82c2,1.14,3.7,1.56,5,1.2a2.3,2.3,0,0,0,1.43-1,.5.5,0,0,1,.15-.17c.08-.06,7.88-5.77,10.06-9.25,1.62-2.61,5.08-18.12,1.14-24a4.68,4.68,0,0,0-5.1-2,.5.5,0,0,1-.49-.21A22.22,22.22,0,0,0,267.6,54.37Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.06,83.14s-5.73,7.65-4.73,9.36,4.67.83,4.67.83",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254,94.07a3.42,3.42,0,0,1-3.1-1.31c-1.07-1.86,3.38-8.06,4.77-9.92a.5.5,0,0,1,.7-.1.51.51,0,0,1,.1.7c-2.66,3.55-5.21,7.93-4.7,8.81.66,1.14,3.2.82,4.12.6a.51.51,0,0,1,.61.37.5.5,0,0,1-.37.6A9.65,9.65,0,0,1,254,94.07Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.8,72.68c-3.51,2.54-2.88,8.38-3.07,12.14q-.39,7.94-.43,15.88c0,3.36,8.65,3.94,10.24,3l-2.13,13.16L281.05,111l-.11-11s-5.9-.3-8.9-7.33S270.4,70.8,270.4,70.8,261.22,70.21,257.8,72.68Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.41,117.38a.49.49,0,0,1-.32-.12.5.5,0,0,1-.17-.46l2-12.35a14.55,14.55,0,0,1-8.4-1.24,2.91,2.91,0,0,1-1.73-2.51c0-5.28.18-10.63.44-15.91,0-.63,0-1.31.05-2,.05-3.66.1-8.21,3.22-10.47h0c3.53-2.56,12.55-2,12.93-2a.54.54,0,0,1,.35.18.48.48,0,0,1,.11.37c0,.15-1.3,14.76,1.61,21.59,2.83,6.63,8.24,7,8.47,7a.51.51,0,0,1,.47.5l.11,11a.5.5,0,0,1-.35.48l-18.63,5.93Zm2.13-14.16a.52.52,0,0,1,.29.09.5.5,0,0,1,.21.49l-2,12.36,17.51-5.57-.1-10.18c-1.51-.23-6.25-1.43-8.87-7.58-2.72-6.4-1.94-18.82-1.72-21.55-1.95-.08-9-.21-11.77,1.81s-2.77,6.24-2.81,9.68c0,.73,0,1.43-.05,2.07-.26,5.26-.41,10.6-.44,15.86q0,.93,1.23,1.65c2.4,1.39,7.25,1.53,8.27.94A.59.59,0,0,1,264.54,103.22Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.65,96.76A27.22,27.22,0,0,0,261,95.41",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.65,97.26a.5.5,0,0,1-.5-.46.49.49,0,0,1,.47-.53,27.93,27.93,0,0,0,6.25-1.33.5.5,0,0,1,.33,1,27.89,27.89,0,0,1-6.51,1.37Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266,87.12a7.2,7.2,0,0,1,1.69-3.54,10,10,0,0,1,2.06-2.29,3.48,3.48,0,0,1,2.9-.71,3.22,3.22,0,0,1,2,1.77,6,6,0,0,1,.51,2.66,11.34,11.34,0,0,1-5.82,9.75l.31-.3",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.31,95.26a.5.5,0,0,1-.34-.86l.29-.28.07.06a10.89,10.89,0,0,0,5.3-9.17,5.64,5.64,0,0,0-.46-2.45,2.72,2.72,0,0,0-1.65-1.49,3,3,0,0,0-2.48.62,9.94,9.94,0,0,0-2,2.18,6.91,6.91,0,0,0-1.59,3.28.52.52,0,0,1-.54.47.5.5,0,0,1-.46-.54,7.61,7.61,0,0,1,1.79-3.8,10.52,10.52,0,0,1,2.16-2.39,3.94,3.94,0,0,1,3.33-.79,3.68,3.68,0,0,1,2.29,2,6.55,6.55,0,0,1,.56,2.88,11.92,11.92,0,0,1-6.08,10.19A.5.5,0,0,1,269.31,95.26Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 257.85,
    cy: 79.11,
    rx: 1.89,
    ry: 0.74,
    transform: "translate(150.31 326.46) rotate(-83.56)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.54,114.43l-1.21-5.93H259.94l-3,8.52A46.07,46.07,0,0,0,284.54,114.43Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.3,118.52a39.53,39.53,0,0,1-9.54-1,.55.55,0,0,1-.31-.25.51.51,0,0,1,0-.4l3-8.51a.5.5,0,0,1,.47-.34h23.39a.5.5,0,0,1,.49.4l1.21,5.93a.5.5,0,0,1-.3.56A48.38,48.38,0,0,1,266.3,118.52Zm-8.75-1.87A46.62,46.62,0,0,0,284,114.12L282.92,109H260.29Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.84,211.55s8.86-72.49-1.66-87.31-36.34-17.21-48.29-7.65S235,219.52,235,219.52,267.21,223.48,302.84,211.55Z",
    fill: "#232020",
    className: "target-color"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.25,176.52c1-2.83,10.78-5.59,13.88-5.59,2,0,7.48,2.4,11,4.06h0l33.92,3.55,18.33-31.85,16.52,18.83s-12.39,30.18-18,32.18-54.22-11.56-54.22-11.56L173.44,183c-4.28,1.33-8.12-2.95-8.12-3.39s-1.77,4.57-3.1,4.43S162.22,179.35,163.25,176.52Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.2,198.38c-10.38,0-50.83-11.24-52.67-11.75l-11.09-3.07a7.64,7.64,0,0,1-6.5-1.52,10.44,10.44,0,0,1-1.57-1.42c-1,2.09-2,4.07-3.21,3.95a1,1,0,0,1-.75-.48c-.8-1.29.52-5.4,1.37-7.74h0c1.19-3.25,11.36-5.91,14.35-5.91,2.05,0,7.17,2.2,11.14,4.06L221.78,178l18.16-31.57a.49.49,0,0,1,.39-.24.47.47,0,0,1,.42.16l16.52,18.83a.49.49,0,0,1,.09.52c-.51,1.24-12.54,30.41-18.32,32.46A6.09,6.09,0,0,1,237.2,198.38Zm-63.76-15.84.13,0,11.22,3.1c16.76,4.67,49.59,13.09,53.92,11.56s14.08-23.06,17.61-31.61l-15.86-18.06-18,31.24a.51.51,0,0,1-.49.25l-33.92-3.56a.42.42,0,0,1-.16,0c-5.49-2.58-9.33-4-10.79-4-3.24,0-12.54,2.86-13.41,5.25-1.54,4.21-1.77,6.61-1.44,6.9.18,0,.75-.28,2.22-3.49.38-.82.49-1.06.92-1a.54.54,0,0,1,.39.42c.31.63,3.74,4.17,7.48,3Zm-7.62-2.89Zm0-.12Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.89,116.59l-23.4,38.65,27.41,16.43,18.23-36.83S259.4,117.27,252.89,116.59Z",
    fill: "#232020",
    className: "target-color"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.89,222.1h14l16.62-75a25.25,25.25,0,0,1,24.64-19.79h30.18a25.24,25.24,0,0,1,24.73,30.3L333,246.12l-83.31-.57H222.05v-4.61A18.84,18.84,0,0,1,240.89,222.1Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333,246.62h0l-83.3-.57H222.05a.5.5,0,0,1-.5-.5v-4.61a19.36,19.36,0,0,1,19.34-19.34h13.59L271,147a25.59,25.59,0,0,1,25.13-20.18h30.18a25.75,25.75,0,0,1,25.22,30.9l-18.06,88.52A.5.5,0,0,1,333,246.62Zm-110.44-1.57h27.13l82.9.57,18-88.12a24.74,24.74,0,0,0-24.24-29.7H296.14A24.6,24.6,0,0,0,272,147.2l-16.61,75a.51.51,0,0,1-.49.39h-14a18.36,18.36,0,0,0-18.34,18.34Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.81,
    y: 210.66,
    width: 115.8,
    height: 35.47,
    transform: "translate(225.41 456.78) rotate(-180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.6,246.62H54.81a.5.5,0,0,1-.5-.5V210.66a.5.5,0,0,1,.5-.5H170.6a.5.5,0,0,1,.5.5v35.46A.5.5,0,0,1,170.6,246.62Zm-115.29-1H170.1V211.16H55.31Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.6,
    y: 210.66,
    width: 8.95,
    height: 35.47,
    transform: "translate(350.16 456.78) rotate(-180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.55,246.62h-9a.5.5,0,0,1-.5-.5V210.66a.5.5,0,0,1,.5-.5h9a.5.5,0,0,1,.5.5v35.46A.5.5,0,0,1,179.55,246.62Zm-8.45-1h8V211.16h-8Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 107.64,
    y1: 181.11,
    x2: 83.05,
    y2: 181.11,
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.64,181.61H83.05a.5.5,0,0,1,0-1h24.59a.5.5,0,0,1,0,1Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 107.64,
    y1: 190.17,
    x2: 76.23,
    y2: 190.17,
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.64,190.67H76.23a.51.51,0,0,1-.5-.5.5.5,0,0,1,.5-.5h31.41a.5.5,0,0,1,.5.5A.51.51,0,0,1,107.64,190.67Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.9,166a.43.43,0,0,1-.22-.06.5.5,0,0,1-.23-.67c5.37-10.9,13.87-28.79,13.78-30.35a.49.49,0,0,1,.36-.6.51.51,0,0,1,.61.38c.46,1.76-10.49,24.18-13.85,31A.52.52,0,0,1,256.9,166Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.57,238.89h-.1a.49.49,0,0,1-.39-.59c.13-.64,13.28-64.73,20-98a.49.49,0,0,1,.58-.4.51.51,0,0,1,.4.59c-6.68,33.33-19.83,97.42-20,98.06A.5.5,0,0,1,270.57,238.89Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.14,82a.5.5,0,0,1-.5-.5.51.51,0,0,1,.5-.5l10.2,0h0a.5.5,0,0,1,.5.5.49.49,0,0,1-.49.5l-10.21,0Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.81,82a.5.5,0,0,1,0-1L144.1,81h0a.5.5,0,0,1,.5.5.5.5,0,0,1-.5.5L113.81,82Z",
    fill: "#232020",
    className: "target-color"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.76,85.94a.5.5,0,1,1,0-1l10.21,0h0a.51.51,0,0,1,.5.5.5.5,0,0,1-.5.5l-10.2,0Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.05,85.92a.5.5,0,0,1,0-1l16.43,0h0a.5.5,0,0,1,.5.49.51.51,0,0,1-.5.51l-16.43,0Z",
    fill: "#232020",
    className: "target-color"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.75,85.87a.5.5,0,0,1,0-1l16.43,0h0a.5.5,0,0,1,.5.5.5.5,0,0,1-.5.5l-16.43,0Z",
    fill: "#232020",
    className: "target-color"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.09,89.85a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5l10.2,0h0a.5.5,0,0,1,.5.5.5.5,0,0,1-.5.5l-10.2,0Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.46,89.82a.5.5,0,1,1,0-1l14.34,0h0a.51.51,0,0,1,.5.5.5.5,0,0,1-.5.5l-14.35,0Z",
    fill: "#232020",
    className: "target-color"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.22,89.79a.51.51,0,0,1-.5-.5.5.5,0,0,1,.5-.5l5.87,0h0a.5.5,0,0,1,.5.5.5.5,0,0,1-.5.5l-5.86,0Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.42,93.75a.49.49,0,0,1-.5-.49.51.51,0,0,1,.5-.51l10.2,0h0a.5.5,0,0,1,.5.5.5.5,0,0,1-.5.5l-10.2,0Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.33,93.73a.5.5,0,0,1,0-1l21,0h0a.5.5,0,0,1,.5.5.5.5,0,0,1-.5.5l-21,0Z",
    fill: "#232020",
    className: "target-color"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.75,93.68a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5l10.2,0h0a.5.5,0,0,1,0,1l-10.2,0Z",
    fill: "#232020",
    className: "target-color"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.35,97.67a.51.51,0,0,1-.5-.5.5.5,0,0,1,.5-.5l5.41,0h0a.51.51,0,0,1,.5.5.5.5,0,0,1-.5.5l-5.42,0Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.24,97.65a.51.51,0,0,1-.5-.5.5.5,0,0,1,.5-.5l23.64-.05h0a.5.5,0,0,1,.5.5.5.5,0,0,1-.5.5l-23.64.05Z",
    fill: "#232020",
    className: "target-color"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.68,101.57a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5l10.2,0h0a.5.5,0,0,1,0,1l-10.2,0Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.52,105.47a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5l20.35,0h0a.5.5,0,0,1,.5.5.5.5,0,0,1-.5.5l-20.35,0Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.25,105.43a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5l14.15,0a.51.51,0,0,1,.5.5.5.5,0,0,1-.5.5l-14.15,0Z",
    fill: "#232020",
    className: "target-color"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.43,105.39a.5.5,0,0,1,0-1l17.52,0h0a.5.5,0,0,1,.5.5.5.5,0,0,1-.5.5l-17.51,0Z",
    fill: "#232020",
    className: "target-color"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.73,109.38a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5l29.67-.06h0a.5.5,0,0,1,.5.5.5.5,0,0,1-.5.5l-29.67.06Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.42,109.31a.5.5,0,0,1,0-1l13.35,0h0a.5.5,0,0,1,0,1l-13.35,0Z",
    fill: "#232020",
    className: "target-color"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149,109.28a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5l39.69-.08h0a.5.5,0,0,1,0,1l-39.69.08Z",
    fill: "#232020",
    className: "target-color"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.94,113.28a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5l14,0h0a.5.5,0,0,1,.5.5.5.5,0,0,1-.5.5l-14,0Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.76,113.25a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5l10.33,0h0a.5.5,0,0,1,0,1l-10.34,0Z",
    fill: "#232020",
    className: "target-color"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.88,113.22a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5l10.33,0h0a.5.5,0,0,1,0,1l-10.33,0Z",
    fill: "#232020",
    className: "target-color"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.27,117.19a.5.5,0,1,1,0-1l24.8,0h0a.5.5,0,0,1,.5.5.51.51,0,0,1-.5.5l-24.81,0Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.13,117.13a.5.5,0,0,1,0-1l12.41,0h0a.5.5,0,0,1,.5.5.5.5,0,0,1-.5.5l-12.4,0Z",
    fill: "#232020",
    className: "target-color"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.59,117.1a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5l18.89,0h0a.5.5,0,0,1,.5.5.5.5,0,0,1-.5.5l-18.89,0Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.47,117.06a.5.5,0,1,1,0-1l18.89,0a.48.48,0,0,1,.5.5.5.5,0,0,1-.5.5l-18.89,0Z",
    fill: "#232020",
    className: "target-color"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.87,121.08a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5l14.8,0h0a.5.5,0,0,1,0,1l-14.8,0Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.45,121.05a.5.5,0,0,1-.5-.5.49.49,0,0,1,.49-.5l14.8,0h0a.5.5,0,0,1,0,1l-14.8,0Z",
    fill: "#232020",
    className: "target-color"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.14,121a.5.5,0,0,1,0-1l14.8,0h0a.5.5,0,0,1,.5.5.5.5,0,0,1-.5.5l-14.8,0Z",
    fill: "#232020",
    className: "target-color"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.5,121.41a.5.5,0,0,1,0-1l14.8,0h0a.5.5,0,0,1,0,1l-14.8,0Z",
    fill: "#232020",
    className: "target-color"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.4,125a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5l10.2,0h0a.5.5,0,0,1,.5.5.5.5,0,0,1-.5.5l-10.2,0Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124,125a.5.5,0,0,1-.5-.5.49.49,0,0,1,.49-.5l10.21,0h0a.5.5,0,0,1,.5.5.51.51,0,0,1-.5.5L124,125Z",
    fill: "#232020",
    className: "target-color"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.79,125.28h0l-21.1-.35a.5.5,0,0,1,0-1h0l21.1.35a.5.5,0,0,1,.49.51A.49.49,0,0,1,157.79,125.28Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.22,81.94a.5.5,0,0,1,0-1l13.79,0h0a.5.5,0,0,1,0,1l-13.79,0Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171,81.93a33.52,33.52,0,0,1-3.64-.05.51.51,0,0,1-.34-.62.49.49,0,0,1,.57-.35c.62,0,9.66,0,15.62,0h0a.5.5,0,0,1,0,1C177,81.92,173.26,81.93,171,81.93Z",
    fill: "#232020",
    className: "target-color"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.61,97.59a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5l10.32,0h0a.5.5,0,0,1,0,1l-10.32,0Z",
    fill: "#232020",
    className: "target-color"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114,101.54a.5.5,0,0,1-.5-.5.51.51,0,0,1,.5-.5l7.59,0a.55.55,0,0,1,.5.5.49.49,0,0,1-.49.5l-7.6,0Z",
    fill: "#232020",
    className: "target-color"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.46,101.52a.5.5,0,0,1,0-1l18,0h0a.5.5,0,0,1,.5.5.49.49,0,0,1-.49.5l-18,0Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.12,101.48a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5l35-.08h0a.5.5,0,0,1,.5.5.5.5,0,0,1-.5.5l-35,.08Z",
    fill: "#232020",
    className: "target-color"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.79,132a.53.53,0,0,1-.29-.1l-2.09-1.54a.48.48,0,0,1-.2-.41.48.48,0,0,1,.22-.41l1.75-1.18a.5.5,0,0,1,.69.14.49.49,0,0,1-.13.69l-1.17.79,1.52,1.11a.51.51,0,0,1,.11.7A.49.49,0,0,1,108.79,132Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.19,132a.52.52,0,0,1-.36-.16.5.5,0,0,1,0-.7l1-.94-1.45-1a.5.5,0,0,1-.12-.7.49.49,0,0,1,.69-.12l2,1.36a.49.49,0,0,1,.21.37.56.56,0,0,1-.15.4l-1.41,1.36A.52.52,0,0,1,111.19,132Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.11,104.84a.52.52,0,0,1-.38-.17.51.51,0,0,1,.05-.71c1.27-1.1,3.32-3.3,2.71-5.63a7,7,0,0,0-2.37-3.15c-.44-.4-.9-.83-1.31-1.28a9.9,9.9,0,0,1-.88-11.78.5.5,0,0,1,.83.55,8.88,8.88,0,0,0,.8,10.56c.38.42.82.83,1.24,1.22a7.94,7.94,0,0,1,2.66,3.63c.74,2.85-1.58,5.38-3,6.64A.49.49,0,0,1,216.11,104.84Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.71,103.78a.5.5,0,0,1-.41-.22.49.49,0,0,1,.12-.69,2.91,2.91,0,0,0,.94-3.7,5.59,5.59,0,0,0-.65-.76l-.28-.28a8.52,8.52,0,0,1-2.29-6,4.79,4.79,0,0,1,1.23-3.32.49.49,0,0,1,.7,0,.5.5,0,0,1,0,.71,3.83,3.83,0,0,0-.93,2.62,7.56,7.56,0,0,0,2,5.31l.26.26a6.32,6.32,0,0,1,.78.91,3.89,3.89,0,0,1-1.2,5.06A.46.46,0,0,1,229.71,103.78Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.21,104.85a.5.5,0,0,1-.42-.22.51.51,0,0,1,.14-.7,3.34,3.34,0,0,0,1.48-2.84,7.23,7.23,0,0,0-1.53-3.51c-.23-.35-.46-.7-.68-1.06a13.27,13.27,0,0,1-.26-12.8.5.5,0,0,1,.68-.21.51.51,0,0,1,.2.68A12.26,12.26,0,0,0,223.06,96c.21.34.43.68.66,1a8,8,0,0,1,1.68,4,4.33,4.33,0,0,1-1.92,3.72A.45.45,0,0,1,223.21,104.85Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.58,122.67a9,9,0,0,1-3.76-.88.49.49,0,0,1-.24-.66.5.5,0,0,1,.66-.25c3.66,1.68,6.73.4,8.16-1.6a3.49,3.49,0,0,0,0-4.48.5.5,0,0,1,0-.71.5.5,0,0,1,.71,0,4.45,4.45,0,0,1,.06,5.76A6.87,6.87,0,0,1,229.58,122.67Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.18,128.05c-14.64,0-13.05-20-13.05-20h26.1S231.82,128.05,217.18,128.05Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.18,128.55a11.68,11.68,0,0,1-9-3.69c-5.39-5.83-4.62-16.42-4.58-16.87a.5.5,0,0,1,.5-.46h26.1a.5.5,0,0,1,.5.46c0,.45.81,11-4.58,16.87A11.68,11.68,0,0,1,217.18,128.55Zm-12.58-20c-.08,2.1-.13,10.81,4.35,15.66a11.75,11.75,0,0,0,16.46,0c4.49-4.85,4.43-13.56,4.35-15.65Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.18,128.05c-14.64,0-13.05-20-13.05-20h26.1S231.82,128.05,217.18,128.05Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.18,128.55a11.68,11.68,0,0,1-9-3.69c-5.39-5.83-4.62-16.42-4.58-16.87a.5.5,0,0,1,.5-.46h26.1a.5.5,0,0,1,.5.46c0,.45.81,11-4.58,16.87A11.68,11.68,0,0,1,217.18,128.55Zm-12.58-20c-.08,2.1-.13,10.81,4.35,15.66a11.75,11.75,0,0,0,16.46,0c4.49-4.85,4.43-13.56,4.35-15.65Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.18,128.05c-14.64,0-13.05-20-13.05-20h26.1S231.82,128.05,217.18,128.05Z",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.18,128.55a11.68,11.68,0,0,1-9-3.69c-5.39-5.83-4.62-16.42-4.58-16.87a.5.5,0,0,1,.5-.46h26.1a.5.5,0,0,1,.5.46c0,.45.81,11-4.58,16.87A11.68,11.68,0,0,1,217.18,128.55Zm-12.58-20c-.08,2.1-.13,10.81,4.35,15.66a11.75,11.75,0,0,0,16.46,0c4.49-4.85,4.43-13.56,4.35-15.65Z",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.31,110.28c-.8,1.33-2.94,5.76-.38,6.38,1.58.39,2.25-1.1,2.87-2.21a9.22,9.22,0,0,0,.84-3c1.06,1.25.55,7,3.08,7.46",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.72,119.37h-.1c-1.93-.38-2.36-3-2.71-5.14,0-.28-.09-.57-.14-.84a5.44,5.44,0,0,1-.54,1.31l-.14.26c-.58,1-1.45,2.64-3.27,2.2a2,2,0,0,1-1.41-1.17c-.86-2.07,1.38-5.8,1.48-6a.5.5,0,1,1,.85.52c-.86,1.42-1.87,3.94-1.41,5.06a1,1,0,0,0,.72.58c1,.24,1.51-.52,2.16-1.71l.15-.26a5.29,5.29,0,0,0,.61-1.92c.05-.3.1-.62.19-1a.48.48,0,0,1,.37-.38.5.5,0,0,1,.5.17,7,7,0,0,1,.87,3c.29,1.82.66,4.07,1.91,4.32a.49.49,0,0,1,.4.58A.51.51,0,0,1,238.72,119.37Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.43,71.44l-.16-1.18,4.29-2.79L101.67,69l-3.08,1.91,3.59,1.9-.71,1.48Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.07,75.81h1.06c.44,0,.61-.19.55-.6l-.88-6.51h2.08l.88,6.53c.24,1.78-.41,2.5-2.19,2.5h-1.24Zm.34-10h2.07l.26,1.94h-2.07Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.31,73.27c-.16-1.17.6-1.78,2.59-2,1.16-.17,1.49-.34,1.45-.65s-.49-.58-1.1-.58a1.19,1.19,0,0,0-1.35,1.08L106,70.74c.05-1.34,1.3-2.27,3-2.27,2,0,3.32,1,3.54,2.63l.53,4h-1.88l-.08-.63h0a2.48,2.48,0,0,1-2.06.81A2.44,2.44,0,0,1,106.31,73.27Zm4.43-.63-.09-.63h0c-.11.19-.39.31-1.14.47-.93.19-1.23.36-1.19.68s.35.48,1,.48C110.14,73.64,110.81,73.18,110.74,72.64Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.08,68.7h2.32l2.31,4h0l1.24-4h2.32L118,75.05h-2Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.82,73.27c-.16-1.17.6-1.78,2.59-2,1.16-.17,1.49-.34,1.45-.65s-.49-.58-1.1-.58a1.19,1.19,0,0,0-1.35,1.08l-1.94-.33c0-1.34,1.3-2.27,3-2.27,2,0,3.33,1,3.55,2.63l.53,4h-1.88l-.09-.63h0a2.5,2.5,0,0,1-2.06.81A2.44,2.44,0,0,1,120.82,73.27Zm4.42-.63-.08-.63h0c-.1.19-.39.31-1.13.47-.94.19-1.24.36-1.19.68s.35.48,1,.48C124.65,73.64,125.32,73.18,125.24,72.64Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.93,73.13l1.87-.55a2,2,0,0,0,2,1.11c.84,0,1.28-.16,1.25-.44s-.44-.46-1.72-.65c-2.28-.34-3.27-.93-3.43-2.08s1-2,2.85-2a4.09,4.09,0,0,1,3.74,1.92l-1.79.55a2.05,2.05,0,0,0-1.83-.9c-.67,0-1,.17-1,.44s.36.4,1.77.62c2.23.36,3.24.92,3.4,2.11s-1,2.07-3.12,2.07A4.18,4.18,0,0,1,127.93,73.13Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.33,71.88a2.93,2.93,0,0,1,3.16-3.41,4,4,0,0,1,3.72,2.28l-1.85.59a1.71,1.71,0,0,0-1.62-1.06,1.29,1.29,0,0,0-1.33,1.6,1.76,1.76,0,0,0,1.76,1.59,1.22,1.22,0,0,0,1.33-1l2,.58a2.86,2.86,0,0,1-3.1,2.28A4,4,0,0,1,135.33,71.88Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.71,68.7h2l.08.61h0a2.06,2.06,0,0,1,1.75-.74,4.53,4.53,0,0,1,1.16.15l-.11,1.85a3.73,3.73,0,0,0-1-.12c-1,0-1.5.6-1.34,1.83l.38,2.77h-2.08Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.86,65.77h2.08l.26,1.94h-2.07Zm.41,2.93h2.07l.86,6.35h-2.07Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.43,68.7h2l.08.57h0a2.43,2.43,0,0,1,1.86-.72,3.87,3.87,0,0,1,3.77,3.34,2.76,2.76,0,0,1-2.83,3.34,3.42,3.42,0,0,1-2-.62h0l.42,3.14h-2.07Zm5.62,3.16a1.75,1.75,0,0,0-1.8-1.5c-.85,0-1.45.54-1.36,1.19l.09.69a1.57,1.57,0,0,0,1.7,1.19A1.3,1.3,0,0,0,157.05,71.86Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.56,70.36l.31,2.29c0,.39.22.53.67.53h1.18l.26,1.87h-1.5a2.31,2.31,0,0,1-2.66-2.2l-.34-2.49H159l-.22-1.66h1.5L160,67.05h2.07l.22,1.65h2l.22,1.66Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.63,72.76l3.08-1.9L165.12,69l.71-1.48,5,2.79.16,1.18-4.29,2.8Z",
    fill: "#231f20"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJavascript);
export default __webpack_public_path__ + "static/media/javascript.c4bd3e6975494fe15e59a67a42b4677a.svg";
export { ForwardRef as ReactComponent };